import api from "../api";
import {iniciarRequisicao, logout} from "../../helpers";
import {STATUS_HTTP} from "../statusHTTP";

export const buscarFornecedoresCotacao = async (id_pedido) => {
  let url = `/pedidos-compra/${id_pedido}/cotacao/fornecedores`;

  const config = {
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get(url, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.fornecedores;
  }

  logout();
}

export const buscarDepartamentosFornecedorPedido = async (id_pedido, id_fornecedor) => {
  let url = `/pedidos-compra/${id_pedido}/cotacao/fornecedores/${id_fornecedor}/departamentos`;

  const config = {
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get(url, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.departamentos;
  }

  logout();
}


export const buscarCategoriasFornecedorPedido = async (id_pedido, id_fornecedor) => {
  let url = `/pedidos-compra/${id_pedido}/cotacao/fornecedores/${id_fornecedor}/departamentos/categorias`;

  const config = {
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get(url, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.produtos;
  }

  logout();
}
